/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./createTarget.defs.js";
export { main as default } from "./createTarget.defs.js";
